export default class PitchToggle {
  constructor({ bearing = -20, pitch = 70, minpitchzoom = null }) {
    this._bearing = bearing
    this._pitch = pitch
    this._minpitchzoom = minpitchzoom
  }

  onAdd(map) {
    this._map = map

    this._btn = document.createElement('button')
    this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d'
    this._btn.type = 'button'
    this._btn['aria-label'] = 'Toggle Pitch'
    this._btn.onclick = () => {
      if (map.getPitch() === 0) {
        const options = { pitch: this._pitch, bearing: this._bearing }
        if (this._minpitchzoom && map.getZoom() > this._minpitchzoom) {
          options.zoom = this._minpitchzoom
        }
        map.easeTo(options)
        this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d'
      } else {
        map.easeTo({ pitch: 0, bearing: 0 })
        this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d'
      }
    }

    this._container = document.createElement('div')
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group'
    this._container.appendChild(this._btn)

    return this._container
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container)
    this._map = undefined
  }

  on() {
    console.log('PITCH ON')
  }

  off() {
    console.log('PITCH OFF')
  }
}
